<div class="container">
  <div class="crew-header">
    <form #chartForm="ngForm">
      <p>
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Charts</mat-label>
          <mat-select name="client" placeholder="Charts" [(ngModel)]="chartType" (ngModelChange)="hint(myInputRef)"
            required>
            <mat-option *ngFor="let item of charts" [value]="item">{{item}}</mat-option>
          </mat-select>
          <mat-hint style="font-size: 12px; left: 2px;">{{chartHints}}</mat-hint>
          <mat-error>*Charts is required</mat-error>
        </mat-form-field>
      </p>
      <p style="display: flex; align-items: center;">
        <mat-icon style="margin-right: 5px;">info</mat-icon>
        Please fill the required fields below to Generate your chart
      </p>
      <div style="display: block;">
        <div style="display: inline-block; margin-right: 30px;">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>{{ chartType == "Pie" ? "Axis" : "X-axis"}}</mat-label>
            <mat-select name="axis-1" [style.pointer-events]="chartType == 'pie' ? 'Axis' : 'X-axis'"
              [(ngModel)]="option1" (ngModelChange)="chartCreation()" required>
              <mat-option *ngFor="let item of axes" [value]="item">{{item}}</mat-option>
            </mat-select>
            <mat-hint *ngIf="!option1" style="font-size: 12px; left: 2px;">Please select a axis data</mat-hint>
            <mat-error>*{{ chartType == "pie" ? "Axis" : "X-axis"}} is required</mat-error>
          </mat-form-field>
        </div>
        <div style="display: inline-block;">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Y-axis</mat-label>
            <mat-select name="axis-2" placeholder="Y-axis" [(ngModel)]="option2" (ngModelChange)="chartCreation()"
              #myInputRef="ngModel" [required]="chartType == 'pie' ? 'false' : 'true'" [disabled]="chartType == 'pie' ? 'true' : 'false'">
              <mat-option *ngFor="let item of axes" [value]="item">{{item}}</mat-option>
            </mat-select>
            <mat-hint *ngIf="!option2" style="font-size: 12px; left: 2px;">
              {{ chartType == "pie" ? "PieChart has only one axis" : "Please select a axis data"}}
            </mat-hint>
            <mat-error>*Y-axis is required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="chartOptions ? chartOptions.series ?  chartOptions?.series.length > 0 : false : false">
        <highcharts-chart #chart [Highcharts]="highcharts" [options]="chartOptions" [(update)]="updateFlag"
          style="width: 100%; height: 100%; ">
        </highcharts-chart>
      </div>
      <p style="margin-top: 10px;" *ngIf="chartOptions ? chartOptions.series ?  chartOptions?.series.length > 0 : false : false">
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Chart Name</mat-label>
          <input matInput [(ngModel)]="chartName" type="text" name="chartName" required />
          <mat-hint *ngIf="!chartName" style="font-size: 12px; left: 2px; white-space: nowrap;">Please name the chart
            with respect to the usage or data for better understanding</mat-hint>
          <mat-error>*Chart Name is required</mat-error>
        </mat-form-field>
      </p>
      <p *ngIf="chartOptions ? chartOptions.series ?  chartOptions?.series.length > 0 : false : false">
        <button color="primary" class="button float-left" [disabled]="!chartForm.valid || !(chartOptions ? chartOptions.series ?  chartOptions?.series.length > 0 : false : false)"
          (click)="save()" mat-raised-button>Save</button>
      </p>
    </form>
  </div>
</div>
